export const PIN_TOOLTIP_TYPE = 'tooltip';
export const PIN_BUTTON_TYPE = 'button';
export const GROUP_TYPE = 'group';
export const BANNER_TYPE = 'banner';
export const LAUNCHPAD_TYPE = 'launchpad';
export const MOBILE_DEFAULT_TYPE = 'mobile';
export const MOBILE_EMBED_TYPE = 'mobile_embed';
